import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { HouseDoor, Wifi, Wind, House, Gear, PersonLinesFill, Flower1, HeartFill, Water, Building, CarFront, Airplane, Briefcase, Calendar3EventFill } from 'react-bootstrap-icons';

const amenities = [
  [
    { label: "Room service", icon: <HouseDoor className="text-warning me-2" size={20} /> },
    { label: "Free WiFi", icon: <Wifi className="text-warning me-2" size={20} /> },
    { label: "Air conditioning", icon: <Wind className="text-warning me-2" size={20} /> },
    { label: "Daily housekeeping", icon: <House className="text-warning me-2" size={20} /> },
    { label: "Laundry service", icon: <Gear className="text-warning me-2" size={20} /> },
  ],
  [
    { label: "24/7 front desk", icon: <PersonLinesFill className="text-warning me-2" size={20} /> },
    { label: "Spa & wellness", icon: <Flower1 className="text-warning me-2" size={20} /> },
    { label: "Fitness center", icon: <HeartFill className="text-warning me-2" size={20} /> },
    { label: "Swimming pool", icon: <Water className="text-warning me-2" size={20} /> },
    { label: "Restaurant", icon: <Building className="text-warning me-2" size={20} /> },
  ],
  [
    { label: "Free parking", icon: <CarFront className="text-warning me-2" size={20} /> },
    { label: "Airport shuttle", icon: <Airplane className="text-warning me-2" size={20} /> },
    { label: "Business center", icon: <Briefcase className="text-warning me-2" size={20} /> },
    { label: "Meeting rooms", icon: <Calendar3EventFill className="text-warning me-2" size={20} /> },
    { label: "Event space", icon: <Building className="text-warning me-2" size={20} /> },
  ],
];

export default function AmenitiesSection() {
  return (
    <Row className="g-4">
      {amenities.map((column, columnIndex) => (
        <Col key={columnIndex} md={4}>
          <ul className="list-unstyled">
            {column.map((amenity, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: (columnIndex * 5 + index) * 0.1 }}
                className="mb-3 d-flex align-items-center pb-2 border-opacity-50 border-bottom border-1 border-warning"
              >
                {amenity.icon} {amenity.label}
              </motion.li>
            ))}
          </ul>
        </Col>
      ))}
    </Row>
  );
}
